export default __webpack_public_path__ + "static/darin-e045169cfe3137497828d3d3e297c30e.png";